import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/pro-regular-svg-icons";
import { Button, Col, Row, Table } from "antd";

import { GET } from "../../../../../providers/useAxiosQuery";
import { apiUrl } from "../../../../../providers/companyInfo";

export default function PageDataImportContent(props) {
	const { width } = props;

	const tableFilter = {
		sort_field: "created_at",
		sort_order: "desc",
		template_types: "Faculty Load",
	};

	const { data: dataSource } = GET(
		`api/data_import_history?${new URLSearchParams(tableFilter)}`,
		"data_import_history_list",
	);

	const columns = [
		{
			title: "Date",
			key: "created_at",
			dataIndex: "created_at_date_format",
			width: 110,
		},
		{
			title: "Time",
			key: "created_at",
			dataIndex: "created_at_time_format",
			width: 100,
		},
		{
			title: "Template Type",
			key: "template_type",
			dataIndex: "template_type_format",
			width: 180,
		},
		{
			title: "File Name",
			key: "file_name",
			dataIndex: "file_name",
			width: 320,
		},
		{
			title: "Failed Import",
			key: "failed_import",
			dataIndex: "failed_import",
			width: 130,
			align: "center",
			render: (text, record) => {
				let failedImportLink = record.attachments.find(
					(att) => att.file_description === "Data Import Errors File",
				);

				failedImportLink = failedImportLink
					? apiUrl(failedImportLink.file_path)
					: null;

				console.log("failedImportLink:", failedImportLink);
				return (
					<Button
						type="link"
						href={failedImportLink}
						target="_blank"
						disabled={!failedImportLink}
						icon={<FontAwesomeIcon icon={faDownload} />}
					/>
				);
			},
		},
		{
			title: "File Size",
			key: "file_size",
			dataIndex: "file_size",
			width: 100,
		},
	];

	return (
		<Row gutter={[20, 20]}>
			<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
				<Table
					id="tbl_data_imports"
					dataSource={dataSource?.data || []}
					scroll={{ x: width <= 575 ? "max-content" : "100%" }}
					columns={columns}
				/>
			</Col>
		</Row>
	);
}
